import { Component, Input } from '@angular/core';
import { Form } from '../../models/form/form.model';
import { ProjectItemType } from '../../models/project/project-item-type.enum';
import { ProjectSectionItem } from '../../models/project/project-section-item.model';
import { ProjectSectionUnitListRequest } from '../../models/project/project-section-unit-list-request.model';
import { ProjectSectionUnit } from '../../models/project/project-section-unit.model';
import { OrganizationType } from '../../models/staff/organization-type.enum';
import { NzTreeNode } from '../../models/tree-node.model';
import {
  FormCodeWbsHistory,
  GlobalService,
} from '../../providers/global.service';
import { ProjectSectionItemService } from '../../services/project-section-item.service';
import { ProjectWbsService } from '../../services/project-wbs.service';
import { DialogConfig } from '../alert-dialog/dialog-config';
import { ProjectItemTypeMap } from './../../models/project/project-item-type.enum';

@Component({
  selector: 'app-dialog-wbs-choose',
  templateUrl: './dialog-wbs-choose.component.html',
  styleUrls: ['./dialog-wbs-choose.component.scss'],
})
export class DialogWbsChooseComponent {
  @Input()
  data!: DialogConfig<WbsChooseConfig>;

  editing: { [name: string]: boolean } = {};

  unitCascaderValue: any[] = [];

  layerCascaderValue: any[] = [];

  type: ProjectItemType = ProjectItemType.SECTION;

  ProjectItemTypeMap = ProjectItemTypeMap;

  history: FormCodeWbsHistory[] = [];

  unitTreeNodes: NzTreeNode[] = [];

  needSegment = false;
  layer = false;

  OrganizationType = OrganizationType;

  onUnitCascaderValueChange(event: any[]) {
    this.unitCascaderValue = event;
    if (this.unitCascaderValue.length > 0) {
      this.searchFormList(
        this.unitCascaderValue[this.unitCascaderValue.length - 1]
      );
    }
  }

  private searchFormList(sectionItemId: number) {
    this.projectSectionItemService
      .findById(sectionItemId)
      .subscribe((item: ProjectSectionItem) => {
        if (item) {
          console.log(item);
          const form = this.data.data!.form!;
          if (
            (form.code?.includes('JLCL') || form.code?.includes('GL225')) &&
            item.isLJ
          ) {
            this.needSegment = true;
            this.fetchSegement(item.projectTypeCode === '2001.001.001.002');
          }
        }
      });
  }

  private fetchSegement(layer: boolean) {
    this.layer = layer;
    const searchRequest = new ProjectSectionUnitListRequest();
    searchRequest.projectId = this.globalService.projectId;
    searchRequest.sectionItemType = layer ? undefined : ProjectItemType.SEGMENT;
    searchRequest.sectionId = this.unitCascaderValue[0];
    searchRequest.sectionSectionItemId =
      this.unitCascaderValue[this.unitCascaderValue.length - 1];
    this.projectWbsService
      .findAll(searchRequest)
      .subscribe((response: ProjectSectionUnit[]) => {
        const filteredResponse: ProjectSectionUnit[] = [];
        const tree: NzTreeNode[] = [];
        const segments: { [key: string]: NzTreeNode } = {};
        if (this.layer) {
          const layerGroup: { [key: string]: ProjectSectionUnit[] } = {};
          for (const item of response) {
            if (item.sectionItemType !== ProjectItemType.LAYER) {
              continue;
            }
            const key = `${item.segmentCode ?? 'DD'}-${
              item.partitionCode ?? 'PP'
            }`;
            if (!layerGroup[key]) {
              layerGroup[key] = [];
            }
            layerGroup[key].push(item);
          }
          for (const key in layerGroup) {
            layerGroup[key].sort((a, b) => {
              if (a.code === b.code) {
                return 0;
              }
              if (!a.code) {
                return 1;
              }
              if (!b.code) {
                return -1;
              }
              return a.code!.localeCompare(b.code!);
            });
          }
          for (const key in layerGroup) {
            const items = layerGroup[key];
            if (items.length > 0) {
              const item = items[items.length - 1];
              filteredResponse.push(item);
            }
          }
          filteredResponse.sort((a, b) => {
            if (a.code === b.code) {
              return 0;
            }
            if (!a.code) {
              return 1;
            }
            if (!b.code) {
              return -1;
            }
            return a.code!.localeCompare(b.code!);
          });
          for (const item of filteredResponse) {
            if (!segments[item.segmentCode!]) {
              segments[item.segmentCode!] = {
                label: `${item.segmentCode}`,
                value: item.segmentCode,
                children: [],
              };
            }
            segments[item.segmentCode!].children!.push({
              label: item.code,
              value: item.sectionItemId,
              isLeaf: true,
            });
          }
          for (const key in segments) {
            if (segments.hasOwnProperty(key)) {
              tree.push(segments[key]);
            }
          }
          this.unitTreeNodes = tree.sort((a, b) => {
            if (a.label === b.label) {
              return 0;
            }
            if (!a.label) {
              return 1;
            }
            if (!b.label) {
              return -1;
            }
            return a.label!.localeCompare(b.label!);
          });
        } else {
          for (const item of response) {
            item.segmentCode = item.code;
            if (!segments[item.segmentCode!]) {
              segments[item.segmentCode!] = {
                label: `${item.segmentCode}`,
                value: item.sectionItemId,
                isLeaf: true,
              };
            }
          }
          for (const key in segments) {
            if (segments.hasOwnProperty(key)) {
              tree.push(segments[key]);
            }
          }
          this.unitTreeNodes = tree;
        }
      });
  }

  constructor(
    private projectSectionItemService: ProjectSectionItemService,
    private projectWbsService: ProjectWbsService,
    private globalService: GlobalService
  ) {}

  private handleOldHistory() {
    const history = this.globalService.getFormCodeWbsHistory(
      this.data.data!.formCode!
    );
    if (!!history) {
      const newHistory: FormCodeWbsHistory[] = [];
      for (const item of history) {
        if (item.length === 0) {
          continue;
        }
        newHistory.push(item);
      }
      this.globalService.clearFormCodeWbsHistory(this.data.data!.formCode!);
      this.globalService.setFormCodeWbsHistoryV2(
        this.data.data!.formCode!,
        newHistory
      );
    }
  }

  ngOnInit() {
    if (this.data.data) {
      this.handleOldHistory();
      this.type = this.data.data.projectItemType ?? ProjectItemType.SECTION;
      this.history =
        this.globalService.getFormCodeWbsHistoryV2(this.data.data.formCode!) ??
        [];
    }
  }

  onBlur() {
    this.editing = {};
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  chooseHistory(index: number) {
    const history = JSON.parse(
      JSON.stringify(this.history[index])
    ) as FormCodeWbsHistory;
    this.unitCascaderValue = history.unitCascaderValue ?? [];
  }

  get canConfirm() {
    if (this.needSegment && this.layerCascaderValue.length === 0) {
      return false;
    }
    return this.unitCascaderValue.length > 0;
  }

  private submit() {
    let contain = false;
    for (const item of this.history) {
      if (
        JSON.stringify(item.unitCascaderValue) ===
        JSON.stringify(this.unitCascaderValue)
      ) {
        contain = true;
        break;
      }
    }
    if (!contain) {
      this.history.push({
        unitCascaderValue: this.unitCascaderValue,
      });
      this.history = this.history.slice(-5);
      this.globalService.setFormCodeWbsHistoryV2(
        this.data.data!.formCode!,
        this.history
      );
    }
    this.data.onConfirm!([
      ...this.unitCascaderValue,
      ...this.layerCascaderValue,
    ]);
  }
}

export class WbsChooseConfig {
  projectItemType?: ProjectItemType;
  sectionType?: OrganizationType;
  formCode?: string;
  stage?: number;
  form?: Form;
}
